module.exports = __webpack_public_path__ + "media/images/icon-cash-on@3x-6ee386786b7eee5edccf3b04ec4cb3d8.png";